import { render, staticRenderFns } from "./ListFolders.vue?vue&type=template&id=6217b62b&scoped=true&lang=pug&"
import script from "./ListFolders.vue?vue&type=script&lang=js&"
export * from "./ListFolders.vue?vue&type=script&lang=js&"
import style0 from "./ListFolders.vue?vue&type=style&index=0&id=6217b62b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6217b62b",
  null
  
)

export default component.exports